import {RouterType} from "../common/types/router.types";
import {Route, Routes} from "react-router-dom";
import Portfolio from "./portfolio/portfolio";
import Test from "./Test";
import React from "react";
import App from "../App";
import Dashboard from "./dashboard/dashboard";
import Section from "./sections/section";
import PostDetail from "./posts/post-detail";

const appChildren: RouterType[] = [
  {
    path: "/",
    element: <Dashboard />,
    title: "about"
  },
  {
    path: "dashboard",
    element: <Dashboard />,
    title: "about"
  },
  {
    path: "sections",
    element: <Section />,
    title: "about"
  },
  {
    path: "detail",
    element: <PostDetail />,
    title: "about"
  },
  {
    path: '*',
    element: (
      <main style={{ padding: "1rem" }}>
        <p>Page not found!</p>
      </main>
    ),
    title: 'Page not found'
  }
];

const pagesData: RouterType[] = [
  {
    path: "/",
    element: <App />,
    title: "home",
    children: appChildren
  },
  {
    path: "portfolio",
    element: <Portfolio />,
    title: "about"
  },
  {
    path: "test",
    element: <Test />,
    title: "about"
  }
];

const Router = () => {
  const pageRoutes = pagesData.map(({ path, title, element, children }: RouterType) => {
    if (!children) {
      return <Route key={title} path={`/${path}`} element={element} />;
    } else {
      return (
        <Route key={title} path={`/${path}`} element={element}>
          {children.map((children: RouterType) => {
            return (
              <Route key={children.title} path={`/${children.path}`} element={children.element}>
                <Route path={'*'}/>
              </Route>
            );
          })}
        </Route>
      )
    }
  });

  return (
    <Routes>
      {pageRoutes}
    </Routes>
  );
};

export default Router;